// extracted by mini-css-extract-plugin
export var h2 = "RichTextRenderer-module--h2--dac25";
export var h3 = "RichTextRenderer-module--h3--acf09";
export var h4 = "RichTextRenderer-module--h4--bd068";
export var hr = "RichTextRenderer-module--hr--70e51";
export var li = "RichTextRenderer-module--li--75a63";
export var ol = "RichTextRenderer-module--ol--c156c";
export var p = "RichTextRenderer-module--p--0c575";
export var ul = "RichTextRenderer-module--ul--fc449";